import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/StoreContext';
import { Dialog } from '@/components/ui/Dialog';
import styles from './FeedbackSettings.module.css';

interface SwitchRowProps {
  label: string;
  checked: boolean;
  onChange: (val: boolean) => void;
}

function SwitchRow({ label, checked, onChange }: SwitchRowProps) {
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <button
        role="switch"
        aria-checked={checked}
        className={`${styles.track} ${checked ? styles.on : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className={styles.thumb} />
      </button>
    </div>
  );
}

interface FeedbackSettingsProps {
  trigger: React.ReactNode;
}

export const FeedbackSettings = observer(function FeedbackSettings({ trigger }: FeedbackSettingsProps) {
  const { prefs } = useStore();

  return (
    <Dialog trigger={trigger} title="Звук и вибрация">
      <div className={styles.list}>
        <SwitchRow
          label="Звук"
          checked={prefs.sound}
          onChange={(v) => prefs.setSound(v)}
        />
        <SwitchRow
          label="Вибрация"
          checked={prefs.haptics}
          onChange={(v) => prefs.setHaptics(v)}
        />
      </div>
    </Dialog>
  );
});
